import { z } from "zod";

export const getContactSchema = z.object({
	contactId: z.string().nonempty(),
});

export type GetContactSchema = z.infer<typeof getContactSchema>;
